import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { Colors } from '../../theme'

export const gatePaperSx = (isMobile) => (isMobile
  ? {
    position: 'absolute',
    bottom: 0,
    m: 0,
    width: '100%',
    maxWidth: '100%',
    borderRadius: '24px 24px 0 0',
  }
  : {
    width: '100%',
    maxWidth: 400,
    borderRadius: '20px',
  })

export const GateBody = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 8,
  padding: '28px 24px calc(20px + env(safe-area-inset-bottom))',
  textAlign: 'center',
}))

export const GateIcon = styled('span')(() => ({
  display: 'grid',
  placeItems: 'center',
  width: 56,
  height: 56,
  marginBottom: 4,
  borderRadius: 18,
  background: `linear-gradient(135deg, ${Colors.BG_START} 0%, ${Colors.BG_END} 100%)`,
  color: Colors.GREEN_BACKGROUND,
}))

export const GateTitle = styled(Typography)(() => ({
  color: Colors.BG_START,
  fontSize: '1.2rem',
  fontWeight: 700,
}))

export const GateText = styled(Typography)(() => ({
  maxWidth: 320,
  color: Colors.SECONDARY_TEXT,
  fontSize: '0.95rem',
  lineHeight: 1.45,
}))

export const GateHint = styled(Typography)(() => ({
  maxWidth: 320,
  marginTop: 4,
  color: Colors.GRAY_TEXT,
  fontSize: '0.8rem',
  lineHeight: 1.4,
}))

export const GateActions = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  width: '100%',
  maxWidth: 320,
  marginTop: 12,
}))

export const PrimaryButton = styled(Button)(() => ({
  minHeight: 48,
  borderRadius: 12,
  background: Colors.GREEN_BACKGROUND,
  color: Colors.BG_START,
  fontSize: '1rem',
  fontWeight: 700,
  textTransform: 'none',
  '@media (hover: hover)': {
    '&:hover': {
      background: Colors.GREEN_HOVER,
    },
  },
}))

export const SecondaryButton = styled(Button)(() => ({
  minHeight: 44,
  borderRadius: 12,
  borderColor: Colors.GRAY_SEPARATOR,
  color: Colors.BG_START,
  fontSize: '0.95rem',
  fontWeight: 600,
  textTransform: 'none',
}))

export const TextButton = styled(Button)(() => ({
  minHeight: 40,
  color: Colors.SECONDARY_TEXT,
  fontSize: '0.9rem',
  fontWeight: 600,
  textTransform: 'none',
}))
